import { render, staticRenderFns } from "./DisputeChangeEmail.vue?vue&type=template&id=328826a0&"
import script from "./DisputeChangeEmail.vue?vue&type=script&lang=js&"
export * from "./DisputeChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports